export const isIOSWebView = () => {
    const ua = navigator.userAgent || '';
    return /ExpectApp/i.test(ua) || (/iPhone|iPad|iPod/.test(ua) && /AppleWebKit/.test(ua) && !/Safari/.test(ua));
}
